import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import {
  POSTMAN_FILE_NAME,
  POSTMAN_FILE_URL,
  SPEC_FILE_NAME,
  SPEC_FILE_URL,
} from "../utils";

interface DownloadableFile {
  url: string;
  fileName: string;
  labelKey: string;
  isPrimary: boolean;
}

// YOSHI-10464: the Postman collection leads, because importing it and running the token request is
// the shortest path from reading to calling. The OpenAPI contract stays for whoever generates a
// client from it.
const DOWNLOADS: DownloadableFile[] = [
  {
    url: POSTMAN_FILE_URL,
    fileName: POSTMAN_FILE_NAME,
    labelKey: "downloadPostman",
    isPrimary: true,
  },
  {
    url: SPEC_FILE_URL,
    fileName: SPEC_FILE_NAME,
    labelKey: "download",
    isPrimary: false,
  },
];

export const SpecDownload: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3 rounded-md border border-gray-200 bg-gray-50 p-5">
      <h3 className="text-base font-bold">{t("docs.spec.title")}</h3>
      <p className="text-base/relaxed text-gray-400">
        {t("docs.spec.description")}
      </p>
      <div className="flex flex-wrap gap-3">
        {DOWNLOADS.map((file) => (
          <a
            key={file.url}
            // The files are served from public/, so these are plain document links, not routes.
            href={file.url}
            download={file.fileName}
            className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-bold transition-opacity focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
              file.isPrimary
                ? "bg-primary text-white hover:opacity-90"
                : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            <ArrowDownTrayIcon className="h-4 w-4" aria-hidden="true" />
            {t(`docs.spec.${file.labelKey}`)}
          </a>
        ))}
      </div>
      <p className="text-sm/relaxed text-gray-400">{t("docs.spec.postman")}</p>
    </div>
  );
};
